angular.module('elfium').directive('contactList', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: elfiumUrlService.getTemplateUrl('contact', 'contactList'),
        controller: 'contactListController'
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/contact/contactList.ts